var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-2",staticStyle:{"border":"1px solid white","height":"100%"},attrs:{"color":"#3c3c3c"}},[_c('v-container',[_vm._t("title"),_vm._t("body")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }